import { useTranslation } from "next-i18next";
import {
  Body,
  Button,
  FieldBody,
  FieldRowContainer,
  FieldSection,
  FieldTitleContainer,
  FieldImageContainer,
  InfoHeaderContainer,
  InfoTitleContainer,
  LeftContainer,
  RightContainer,
  Title,
  EditTitle,
  ButtonTitle,
} from "./InfoSection.style";
import CheckIcon from "../../CheckIcon/CheckIcon";

export type InfoField = {
  key: string;
  i18nKey: string;
  value: string;
};

export type InfoSectionProps = {
  sectionKey: string;
  sectionI18nKey: string;
  isValid: boolean;
  onEdit: () => void;
  fields: InfoField[];
};

const InfoSection = ({
  sectionKey,
  sectionI18nKey,
  fields,
  isValid,
  onEdit,
}: InfoSectionProps) => {
  const { t } = useTranslation("affiliate");

  return (
    <div data-testid={sectionKey}>
      <InfoHeaderContainer>
        <InfoTitleContainer>
          <Title data-testid={`${sectionKey}-title`} level={7}>
            {t(`payout.${sectionI18nKey}.title`)}
          </Title>
          {isValid && (
            <EditTitle
              data-testid={`${sectionKey}-edit-button`}
              data-gtm-input-code={`${sectionKey}-edit-button`}
              level={7}
              onClick={onEdit}
            >
              {t("payout.editInfoButton")}
            </EditTitle>
          )}
        </InfoTitleContainer>
        <Body level={7}>{t(`payout.${sectionI18nKey}.description`)}</Body>
      </InfoHeaderContainer>
      {fields.map((item) => (
        <FieldRowContainer
          data-testid={`${sectionKey}-${item.key}-section`}
          justify="start"
          align="top"
          wrap
        >
          <LeftContainer flex="192px">
            <FieldSection>
              <FieldImageContainer>
                <CheckIcon correct={!!item.value} />
              </FieldImageContainer>
              <FieldTitleContainer>
                <Title
                  data-testid={`${sectionKey}-${item.key}-section-title`}
                  level={7}
                >
                  {t(`payout.${sectionI18nKey}.${item.i18nKey}`)}
                </Title>
              </FieldTitleContainer>
            </FieldSection>
          </LeftContainer>
          <RightContainer>
            <FieldBody
              data-testid={`${sectionKey}-${item.key}-section-value`}
              level={7}
            >
              {item.value || "-"}
            </FieldBody>
          </RightContainer>
        </FieldRowContainer>
      ))}
      {!isValid && (
        <Button
          data-testid={`${sectionKey}-add-button`}
          data-gtm-input-code={`${sectionKey}-add-button`}
          fullWidth
          type="outlined"
          onClick={onEdit}
        >
          <ButtonTitle level={7}>{t("payout.addInfoButton")}</ButtonTitle>
        </Button>
      )}
    </div>
  );
};

export default InfoSection;
